export const iconFontAwesomeShoppingStripeS = (
	<i className="fa-solid fa-stripe-s"></i>
);
